<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { LayerList } from '@/components/layers'
import { Button } from '@/components/ui/button'
import { PlusCircle, TriangleAlert } from 'lucide-vue-next'

const router = useRouter()
const store = useStore()
const mapReady = computed(() => store.getters['geo/getMapReady'])
const map = computed(() => store.getters['geo/getMap'])

const selectedOrgId = computed(() => store.getters['org/getSelected'])
const selectedOrg = computed(() => store.getters['org/getSelectedOrg'])

const orgLayers = computed(() => {
  return store.getters['layers/getOrgLayers'](selectedOrgId.value)
})

const deleteLayer = (layerId) => {
  store.dispatch('layers/deleteOrgLayer', {
    orgId: selectedOrgId.value,
    layerId
  })
}
</script>

<template>
  <div v-if="map && mapReady && selectedOrg">
    <!-- <div v-if="!hasPlanetscopeAccess" class="mx-1 mb-2 p-3 bg-amber-50 border border-amber-200 rounded-lg">
      <div class="flex items-center text-amber-700">
        <TriangleAlert class="w-4 h-4 mr-2 flex-shrink-0" />
        <div class="text-sm">
          <p class="font-medium">Limited Planet Access</p>
          <p class="text-amber-600 mt-1">
            You don't have access to Planet API. Contact your administrator to enable Planet API access.
          </p>
        </div>
      </div>
    </div> -->

    <div class="px-1 pb-1 flex items-center justify-end">
      <div v-if="selectedOrg" :key="selectedOrg.organization_id">
        <Button class="px-2" variant="ghost" size="sm" @click="router.push({ name: 'LayerCreate', params: { org_id: selectedOrgId } })">
          <div class="flex items-center justify-between">
            <PlusCircle class="text-gray-500 w-4 h-4 mr-1" />
            Add Layer
          </div>
        </Button>
      </div>
    </div>

    <div
      v-if="mapReady && orgLayers?.length > 0 && selectedOrg"
      :key="selectedOrg.organization_id + orgLayers?.length"
      class=""
    >
      <LayerList :layers="orgLayers" :key="orgLayers.length" @deleteLayer="deleteLayer" />
    </div>
    <div v-else>
      <div class="p-3 text-gray-500">No layers found</div>
    </div>
  </div>
</template>
